export const filter = {
    id: "",
    bunk_id: "",
    resource: "", 
    start: "",
    end: "",   
    text: "",
    color: ""
};